import { SimpleTable } from '@nearst/ui';

import styles from './BarcodeVisibilityModal.module.scss';

const ResultsSection = ({ results, operation, affectedChannels = [] }) => {

	if (!results.length) return null;

	const successes = results.filter((result) => !result.failures.length);
	const failures = results.filter((result) => result.failures.length);

	const channelSummary = affectedChannels.length > 0
		? affectedChannels.map((ch) => ch.label).join(', ')
		: null;

	return (
		<div className={styles.resultsSection}>
			<p className={styles.summary}>
				{successes.length > 0 && <span className={styles.successCount}>{successes.length} {operation.successMessage}</span>}
				{successes.length > 0 && failures.length > 0 && ', '}
				{failures.length > 0 && <span className={styles.failureCount}>{failures.length} failed</span>}
			</p>

			<SimpleTable
				data={results}
				fields={[
					{
						title: 'Barcode',
						formatter: (row) => <span className={styles.barcodeCell}>{row.barcode}</span>
					},
					{
						title: 'Status',
						formatter: (row) => row.failures.length
							? <span className={styles.statusFailure}>Failed</span>
							: <span className={styles.statusSuccess}>{operation.type === 'hide' ? 'Hidden' : 'Visible'}</span>
					},
					channelSummary && {
						title: 'Channels',
						formatter: () => <span className={styles.channelsCell}>{channelSummary}</span>
					}
				].filter(Boolean)}
			/>
		</div>
	);
};

export { ResultsSection };
